import { render, staticRenderFns } from "./TabSurveyComplain.vue?vue&type=template&id=daf26a8c&scoped=true"
import script from "./TabSurveyComplain.vue?vue&type=script&lang=js"
export * from "./TabSurveyComplain.vue?vue&type=script&lang=js"
import style0 from "./TabSurveyComplain.vue?vue&type=style&index=0&id=daf26a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf26a8c",
  null
  
)

export default component.exports